module.exports = __webpack_public_path__ + "img/channel_icon_outline.f8bb1c41.svg";